module.exports = __webpack_public_path__ + "banca.png?534c4ed1b85b8d3f04551adb07c736c3";